<template>
  <dd role="group" :aria-label="label" class="zm-select-group__wrap" v-show="visible">
    <dl role="listbox">
      <dt class="zm-select-group__title">
        {{ label }}
      </dt>
      <slot></slot>
    </dl>
  </dd>
</template>

<script type="text/babel">
  import Emitter from '../../mixins/emitter';

  export default {
    mixins: [Emitter],

    name: 'ZmOptionGroup',

    componentName: 'ZmOptionGroup',

    props: {
      label: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        visible: true
      };
    },

    watch: {
      disabled(val) {
        this.broadcast('ZmOption', 'handleGroupDisabled', val);
      }
    },

    methods: {
      queryChange() {
        this.visible = this.$children &&
          Array.isArray(this.$children) &&
          this.$children.some(option => option.visible === true);
      }
    },

    created() {
      this.$on('queryChange', this.queryChange);
    },

    mounted() {
      if (this.disabled) {
        this.broadcast('ZmOption', 'handleGroupDisabled', this.disabled);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(select-group) {
    $gap: 12px;

    margin: 0;
    padding: 0;

    @include e(wrap) {
      position: relative;
      list-style: none;
      margin: 0;
      padding: 0;

      &:not(:last-of-type) {
        padding-bottom: 24px;

        &::after {
          content: '';
          position: absolute;
          display: block;
          left: $gap;
          right: $gap;
          bottom: 12px;
          height: 0;
          border-bottom: 1px solid $--color-border-secondary;
        }
      }
    }

    @include e(title) {
      padding-left: $gap;
      font-size: $--select-group-font-size;
      color: $--select-group-color;
      line-height: $--select-group-height;
    }

    & .zm-select-dropdown__item {
      padding-left: $gap;
    }
  }
</style>
